import { createSelector } from 'reselect';
import { getStadiumConfig } from './getStadiumConfig';

const getIsLoading = (state) => state.loading?.isLoading;
const getPitchFx = (state) => state.pitchfx;
const getUniforms = (state) => state?.uniforms;
const getDisableDynamicUniforms = (state) => state?.config?.disableDynamicUniforms;

const getUniformsData = ({ uniforms, homeOrAway, pitchFx, disableDynamicUniforms }) => {
    let isLoading = true;

    if (uniforms?.isError) {
        return { isLoading: false };
    }

    if (disableDynamicUniforms) {
        return { isLoading: false };
    }

    if (pitchFx?.gamePk && uniforms?.gamePk) {
        isLoading = uniforms?.gamePk !== pitchFx?.gamePk;
    }

    return isLoading ? { isLoading } : { ...uniforms[homeOrAway], isLoading: false };
};

export const getPitchFxState = createSelector(
    [getPitchFx, getIsLoading, getStadiumConfig, getUniforms, getDisableDynamicUniforms],
    (pitchFx, isLoading, stadiumConfig, uniforms, disableDynamicUniforms) => {
        const { forceDefaultStadium, defaultStadium } = stadiumConfig;
        const homeOrAway = pitchFx?.atbat?.homeAway;
        const uniformSet = getUniformsData({ uniforms, homeOrAway, pitchFx, disableDynamicUniforms });
        const batterModel = {
            ...pitchFx,
            atbat: {
                ...pitchFx.atbat,
                uniformData: uniformSet
            }
        };
        return { batterModel, isLoading, forceDefaultStadium, defaultStadium, disableDynamicUniforms };
    }
);
